import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    // Mirrors APIKeyManagement's mainWrapper offset so the pre-body states clear the fixed AppBar.
    statusWrapper: {
        backgroundColor: theme.palette.backgrounds.main,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        marginTop: 64,
        minHeight: "calc(100vh - 64px)",
        width: "100%",
    },
    statusMessage: {
        color: theme.palette.text.primary,
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontSize: theme.typography.subtitle1.fontSize,
        fontWeight: theme.typography.subtitle1.fontWeight,
    },
}));
